// settings-crunch — Settings "Subscription & Billing" layout-crunch hardening.
//
// Pure helpers (no flag read here — callers pass the flag) so BOTH the OFF
// (byte-identical) and ON states are deterministically unit-testable without
// juggling process.env at import time. Gated live by featureFlags.SETTINGS_CRUNCH_FIX.
//
// Two mechanical parts, both presentational (no money/auth/network path):
//
// 1) Plan/tier NAME must never break mid-word ("Premium" -> "Premiu" / "m").
//    The app's shared <TextView> inherits `overflow-wrap: break-word`, so a
//    single-word plan name in a narrow (<~70px) box breaks mid-word UNLESS a
//    `white-space: nowrap` ancestor protects it. These pin the guarantee ON the
//    name element itself (defense-in-depth, independent of ancestor context),
//    degrading to a clean ellipsis instead of a mid-word break or raw overflow.
//
// 2) The Settings left rail (shared NewSidebar) currently maxes at 300px
//    (clamp(200px,20vw,300px)); the fix lowers the max so the rail stops
//    over-consuming content width on wide (>1280px) screens.

// --- Part 1: plan/tier name no-wrap -----------------------------------------
// ISP-9999 R2: the target label is a <TextView> (variant="subtitle"), whose
// shared baseStyles set `display: -webkit-box` (a legacy line-clamp box with
// NO `-webkit-line-clamp` set). That combo conflicts with `text-overflow:
// ellipsis` -- ellipsis only applies to a single-line block/inline-block box,
// not an un-clamped -webkit-box -- so "Premium" hard-clipped to "Premiu"
// instead of degrading to "Premi…". `display: block` here (an inline style,
// so it always wins over the class) resolves the conflict: a normal
// single-line nowrap+ellipsis box, same as every other truncated label.
export const PLAN_NAME_NOWRAP_CSS =
  "display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; overflow-wrap: normal; min-width: 0;";

export const PLAN_NAME_NOWRAP_STYLE = {
  display: "block",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  overflowWrap: "normal",
  minWidth: 0,
};

// styled-components CSS fragment — empty string when OFF (so an interpolation
// site emits nothing and stays byte-identical to today).
export const planNameNoWrapCss = (enabled) => (enabled ? PLAN_NAME_NOWRAP_CSS : "");

// React inline-style object — `undefined` when OFF so a `...(x || {})` spread
// adds no keys (byte-identical style object).
export const planNameNoWrapStyle = (enabled) =>
  enabled ? PLAN_NAME_NOWRAP_STYLE : undefined;

// --- Part 2: Settings left-rail width ---------------------------------------
export const SIDEBAR_WIDTH_DEFAULT = "clamp(200px, 20vw, 300px)";
export const SIDEBAR_WIDTH_FIX = "clamp(200px, 20vw, 260px)";

// Returns the exact current width string when OFF (byte-identical), the
// narrower max when ON.
export const sidebarWidth = (enabled) =>
  enabled ? SIDEBAR_WIDTH_FIX : SIDEBAR_WIDTH_DEFAULT;
